import Modal from "react-bootstrap/Modal";

import { Col, Row } from "react-bootstrap";
import ImageItem from "./ImageItem";

import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import LangChanger from "../../layout/LangChanger";
import SignUp from "../auth/SignUp";
import SignIn from "../auth/SignIn";

const Register = ({
  show,
  setShow,
  handleLogin,
  activeForm,
  setActiveForm,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal show={show}  size="lg" scrollable={true} onHide={()  => setShow(false)} >
        <Modal.Body>
         <div className="p-4">
           <div className="d-flex justify-content-end align-items-center gap-3 text-dark scrollable">
            <LangChanger t={t} />
            <X
              size={27}
              strokeWidth={1.5}
              role="button"
              title={t("close")}
              onClick={() => setShow(false)}
            />
          </div>

          <div className="container pt-3 ">
            <Row className="justify-content-between mt-2">
              <Col >
                <Row className="">
                  <Col sm="6" className="my-3">
                    <button
                      onClick={() => setActiveForm("in")}
                      className={`p-3 w-100 rounded-3 ${
                        activeForm === "in" ? "btn-blue" : "btn-outline-blue"
                      }`}
                    >
                      {t("log_in")}
                    </button>
                  </Col>
                  <Col sm="6" className="my-3">
                    <button
                      onClick={() => setActiveForm("up")}
                      className={`p-3 w-100 rounded-3 ${
                        activeForm === "up" ? "btn-blue" : "btn-outline-blue"
                      }`}
                    >
                      {t("register")}
                    </button>
                  </Col>
                </Row>

                {activeForm === "in" ? (
                  <SignIn />
                ) : (
                  // <SignInApi handleLogin={handleLogin} />
                  // <SignIn handleLogin={handleLogin} />
                  <SignUp />
                )}
              </Col>
 {/* <Col className="d-none d-xl-block" lg="6" xl="5">
                <ImageItem />
              </Col> */}
             
            </Row>
          </div>
         </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Register;
